import React from 'react';
import BaseDropdown from './BaseDropdown';
import { useUsecaseStructure } from './UsecaseStructureContext';

const SubusecaseDropdown = ({ branch, usecase, value, onChange, ...props }) => {
  const { getSubusecases } = useUsecaseStructure();
  const options = getSubusecases(branch, usecase);

  return (
    <BaseDropdown
      options={options}
      value={value}
      onChange={onChange}
      label="Subusecase"
      placeholder="Select a subusecase"
      disabled={!branch || !usecase}
      {...props}
    />
  );
};

export default SubusecaseDropdown; 